import * as React from 'react'
import { connect, ConnectedProps } from 'react-redux'
import { NavigateFunction, useNavigate, useParams } from 'react-router-dom'

import { sortShortlistTracks } from '@disco/state-management/actions/ShortlistActions'
import { getLocationBeforeTransitions } from '@disco/state-management/selectors/routing'
import { getShortlistById } from '@disco/state-management/selectors/shortlists'

import { getShortlistBaseRoute } from 'utils/routing'

import TrackOrderModal from 'components/modals/track-order'

const makeMapStateToProps = () => {
  return (state, { params }) => {
    return {
      shortlist: getShortlistById(state, {
        id: params.shortlistId,
      }),
      location: getLocationBeforeTransitions(state),
    }
  }
}

const mapDispatchToProps = {
  sortShortlistTracks,
}

const connector = connect(makeMapStateToProps, mapDispatchToProps)

type PropsFromRedux = ConnectedProps<typeof connector>

type Props = PropsFromRedux & {
  navigate: NavigateFunction
  params: { shortlistId: string }
}

class ShortlistTrackOrder extends React.Component<Props> {
  _onClose = () => {
    const baseRoute = getShortlistBaseRoute(this.props.location)
    this.props.navigate(baseRoute || '/')
  }
  _onChange = (sortKey, sortDirection) => {
    this.props.sortShortlistTracks(
      this.props.shortlist.id,
      sortKey,
      sortDirection,
    )

    this._onClose()
  }

  render() {
    const { sort_key, sort_direction } = this.props.shortlist
    const sorting =
      sort_key !== 'custom' ? `${sort_key};${sort_direction}` : sort_key
    return (
      <TrackOrderModal
        onClose={this._onClose}
        onChange={this._onChange}
        currentSorting={sorting}
      />
    )
  }
}

const ConnectedShortlistTrackOrder = connector(ShortlistTrackOrder)

export default function ShortlistTrackOrderWithNavigate(
  props: Partial<PropsFromRedux>,
) {
  const navigate = useNavigate()
  const params = useParams<{ shortlistId: string }>()
  return (
    <ConnectedShortlistTrackOrder
      {...props}
      navigate={navigate}
      params={params}
    />
  )
}
